import API_ENDPOINT from "../constants/api_endpoint.constant";
import axios from '../utils/axiosService';

export default class EditService {
    getAllData(agxBusinessType) {
        return axios.get(`${API_ENDPOINT.AGX_FEE_RATE}/user?agxBusinessType=${agxBusinessType}`);
    };
}